import { map } from 'lodash'

export default {
  afterCreated () {
    this.$toast.success('Carro incluido com sucesso.')
    return this.$router.push({name: 'dweller.car.index'})
  },
  afterUpdated () {
    this.$toast.success('Carro alterado com sucesso.')
    return this.$router.push({name: 'dweller.car.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  /** Retornando as torres das uniades do dweller */
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/car/form/resources/methods.js